import { render, staticRenderFns } from "./WebinarDetails.vue?vue&type=template&id=6857f3a7&scoped=true&"
import script from "./WebinarDetails.vue?vue&type=script&lang=js&"
export * from "./WebinarDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857f3a7",
  null
  
)

export default component.exports